import React, { createRef, memo } from 'react';
import { IonFooter, IonInput, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonChip, IonToggle, IonSelect, IonSelectOption } from '@ionic/react';
import '../styles/Flashcards.scss';
import '../styles/Practice.scss';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import Utilities from '../Utilities';
import PatternLock from "react-pattern-lock";

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import { isPlatform } from '@ionic/react';

import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

import PracticeMultichoiceImg from '../images/practice-multichoice.png';
import PracticePatternImg from '../images/practice-pattern.png';
import PracticeConnectImg from '../images/practice-connect.png';

import { CountdownCircleTimer } from 'react-countdown-circle-timer'

import { checkbox, square, logIn, volumeHigh, shuffle, gitCompare, repeat, star, close, closeOutline, closeCircle, ellipse, checkmark, chevronForwardCircle, chevronForward, grid, checkmarkCircle, textOutline, headset, gitMerge, ellipsisHorizontal, create, informationCircleSharp, checkboxOutline, squareOutline } from 'ionicons/icons'
import { createGesture, Gesture } from '@ionic/react';

import { Device } from '@capacitor/device';
import { Keyboard } from '@capacitor/keyboard';
const ALL_PRACTICE_TYPES = [
    "drag-select-term", "drag-select-definition", "drag-pronounce-term", "drag-pronounce-definition",
    "pop-select-term", "pop-select-definition", "pop-pronounce-term", "pop-pronounce-definition",
    "connect-select-term", "connect-select-definition", "connect-pronounce-term", "connect-pronounce-definition",
    // "type-term", "type-definition", "type-pronounce-term", "type-pronounce-definition",
];

const BACKGROUND_COLORS = [
    "#FE7E6D",
    "#4D80E4",
    "#B667F1",
    "#4FBDBA",
    "#2EB086",
    "#FF6464",
];

class Practice extends React.Component {

    constructor(props) {
        super(props);
        this.swiperRef = createRef();
        this.progressBar = createRef();
        this.clickBlocked = false;
        this.currentInputRef = createRef();
        this.nextQuestionTimeout = null;
        this.state = {
            rounds: null,
            currentRound: null,
            currentTypeAnswer: "",
            closeAlert: false,
            inRoundMistakesBuffer: 0,
            inRoundTextBuffer: "",
            inRoundPatternPath: [],
            practiceTypes: [],
            timeoutAfterError: 0,
            timeoutAfterCorrect: 0,
            backgroundColor: window.dark ? "#222" : "#4D80E4",
            pronounceDefinitionOnReview: "true",
            pronounceTermOnReview: "true"
        }
    }

    async componentDidMount() {

        let lastPractice = await Storage.getO("lastPractice");
        if (lastPractice) {
            if (lastPractice.uninited) {
                this.setState({
                    practiceTypes: ALL_PRACTICE_TYPES,
                    timeoutAfterError: 0,
                    timeoutAfterCorrect: 0,
                    pronounceTermOnReview: "true",
                    pronounceDefinitionOnReview: "true"   
                })
            } else {
                let sqlSettings = await SQLStorage.getSettingsObj();
                if (sqlSettings) {
                    this.setState({
                        practiceTypes: sqlSettings.practiceTypesV2 ? sqlSettings.practiceTypesV2.split(",") : ALL_PRACTICE_TYPES,
                        timeoutAfterError: sqlSettings.timeoutAfterError ? parseInt(sqlSettings.timeoutAfterError) : 0,
                        timeoutAfterCorrect: sqlSettings.timeoutAfterCorrect ? parseInt(sqlSettings.timeoutAfterCorrect) : 0,
                        pronounceTermOnReview: sqlSettings.pronounceTermOnReview || "true",
                        pronounceDefinitionOnReview: sqlSettings.pronounceDefinitionOnReview || "true"
                    })
                }
            }
        }
        
        let gesture = createGesture({ el: document.getElementById('practice-ion-page'), threshold: 0, gestureName: 'my-gesture', gesturePriority: 40.5, onMove: ev => { } });
        gesture.enable(true);
    }

    getRandomType(types, term, canPronounceTerm, definition, canPronounceDefinition) {
        if (types.length === 0) {
            types = ALL_PRACTICE_TYPES;
        }
        types = JSON.parse(JSON.stringify(types));

        // console.log("@@@@ ORIGINAL SELECTION", types)

        for (let i = 0; i < types.length; i++) {
            const type = types[i];

            if (!canPronounceTerm && type.indexOf("term") !== -1 &&  type.indexOf("pronounce") !== -1) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pronounce term " + term)
                continue
            }
            
            if (!canPronounceDefinition && type.indexOf("definition") !== -1 && type.indexOf("pronounce") !== -1) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pronounce definition " + definition)
                continue
            }   
            
            if (type.indexOf("term") !== -1 && type.indexOf("connect") !== -1 && (definition.length > 24 || definition.length < 3)) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pattern connect term " + term + " with length" + term.length)
                continue
            }

            if (type.indexOf("definition") !== -1 && type.indexOf("connect") !== -1 && (term.length > 24 || term.length < 3)) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pattern connect definition " + definition + " with length" + definition.length)
                continue
            }

            if (type.indexOf("term") !== -1 && type.indexOf("pop-select") !== -1 && (definition.length > 28 || definition.length < 3)) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pop-select term " + term + " with length" + term.length)
                continue
            }

            if (type.indexOf("definition") !== -1 && type.indexOf("pop-select") !== -1 && ( term.length > 28 || term.length < 3)) {
                types.splice(i, 1);
                i--;
                // console.log("@@@ Cannot pop-select definition " + definition + " with length" + definition.length)
                continue
            }
        }

        // console.log("@@@@ AFTER PRONOUNCE CHECK", types)

        let choice = (types.length !== 0) ? types[Utilities.randomIntFromInterval(0, types.length - 1)] : (Utilities.randomIntFromInterval(0, 1) === 0) ? "drag-select-term" : "drag-select-definition"
        
        // console.log("@@@@ CHOICE: " + choice);

        return choice;
    }

    randomlySplit(word) {
        var groups = [],
            tail = word;
        while (tail.length) {
            var availableLengths = [2, 3, 4];
            if (tail.length <= 3) availableLengths = [tail.length];
            if (tail.length === 4) availableLengths = [2];
            if (tail.length === 5) availableLengths = [2, 3];
            var length = availableLengths[(Math.random() * availableLengths.length) | 0];
            groups.push(tail.slice(0, length));
            tail = tail.slice(length);
        }
        return groups;
    }

    getPossiblePatternPosition(size, prevI) {
        // let THREE = [
        //     [0,1,2],
        //     [3,4,5],
        //     [6,7,8],
        // ]
        if (size === 3) {
            if (prevI === 0) return  [1, 3];
            else if (prevI === 1) return  [0, 2, 4];
            else if (prevI === 2) return  [1, 5];
            else if (prevI === 3) return  [0, 4, 6];
            else if (prevI === 4) return  [1, 3, 5, 7];
            else if (prevI === 5) return  [2, 4, 8];
            else if (prevI === 6) return  [3, 7];
            else if (prevI === 7) return  [4, 6, 8];
            else if (prevI === 8) return  [5, 7];
        } else if (size === 4) {
        // let FOUR = [
        //     [0,1,2,3],
        //     [4,5,6,7],
        //     [8,9,10,11],
        //     [12,13,14,15],
        // ]
            if (prevI === 0) return  [1, 4];
            else if (prevI === 1) return  [0, 5, 2];
            else if (prevI === 2) return  [1, 6, 3];
            else if (prevI === 3) return  [2, 7];
            else if (prevI === 4) return  [0, 5, 8];
            else if (prevI === 5) return  [1, 4, 6, 9];
            else if (prevI === 6) return  [2, 5, 7, 10];
            else if (prevI === 7) return  [3, 6, 11];
            else if (prevI === 8) return  [4, 9, 12];
            else if (prevI === 9) return  [5, 8, 13, 10];
            else if (prevI === 10) return  [6, 9, 14, 11];
            else if (prevI === 11) return  [7, 10, 15];
            else if (prevI === 12) return  [8, 13];
            else if (prevI === 13) return  [12, 9, 14];
            else if (prevI === 14) return  [13, 10, 15];
            else if (prevI === 15) return  [14, 11];
        } else if (size === 5) {
            // let FIVE = [
            //     [00,01,02,03,04],
            //     [05,06,07,08,09],
            //     [10,11,12,13,14],
            //     [15,16,17,18,19],
            //     [20,21,22,23,24]
            // ]
            if (prevI === 0) return  [1, 5];
            else if (prevI === 1) return  [0, 6, 2];
            else if (prevI === 2) return  [1, 7, 3];
            else if (prevI === 3) return  [2, 4, 8];
            else if (prevI === 4) return  [3, 9];
            else if (prevI === 5) return  [0, 6, 10];
            else if (prevI === 6) return  [1, 5, 7, 11];
            else if (prevI === 7) return  [2, 6, 8, 12];
            else if (prevI === 8) return  [3, 7, 9, 13];
            else if (prevI === 9) return  [4, 8, 14];
            else if (prevI === 10) return  [5, 11, 15];
            else if (prevI === 11) return  [6, 10, 12, 16];
            else if (prevI === 12) return  [7, 11, 13, 17];
            else if (prevI === 13) return  [8, 12, 14, 18];
            else if (prevI === 14) return  [9, 13, 19];
            else if (prevI === 15) return  [10, 16, 20];
            else if (prevI === 16) return  [11, 15, 17, 21];
            else if (prevI === 17) return  [12, 16, 18, 22];
            else if (prevI === 18) return  [13, 17, 23, 19];
            else if (prevI === 19) return  [14, 18, 24];
            else if (prevI === 20) return  [15, 21];
            else if (prevI === 21) return  [20, 16, 22];
            else if (prevI === 22) return  [21, 17, 23];
            else if (prevI === 23) return  [22, 18, 24];
            else if (prevI === 24) return  [19, 23];
        }
    }

    getOptions(i, type, cards) {

        if (type.startsWith("select") || type.startsWith("pronounce") || type.startsWith("drag") || type.startsWith("pop") || type.startsWith("connect") ) {

            let cardIndexes = [i];
            let randomCards = [cards[i]];

            if (!cards[i]) {
                cardIndexes = [cards[0].id];
                randomCards = [cards[0]];
            }

            while (cardIndexes.length < 4) {
                let cardIndex = Math.floor(Math.random()*cards.length);
                if (cardIndexes.indexOf(cardIndex) === -1) {
                    cardIndexes.push(cardIndex);
                    randomCards.push(cards[cardIndex])
                }
            }

            let bites = [];
            let wordNeedsSpelling = type.indexOf("-term") > -1 ? randomCards[0].definition : randomCards[0].term;
            let charsToSpell = wordNeedsSpelling.split("");
            if (type.startsWith("pop") || type.startsWith("connect")) { 

                if (wordNeedsSpelling.length < 8 || type.startsWith("connect")) {
                    bites = wordNeedsSpelling.split("");
                    for (let i = 1; i < randomCards.length; i++) {
                        if (type.startsWith("pop")) {
                            bites.push((type.indexOf("-term") > -1 ? randomCards[i].definition : randomCards[i].term).split("")[0]);
                        } else {
                            let randomBites = (type.indexOf("-term") > -1 ? randomCards[i].definition : randomCards[i].term).split("");
                            for (let j = 0; j < randomBites.length; j++) {
                                const randomBite = randomBites[j];
                                if (bites.indexOf(randomBite) === -1) {
                                    bites.push(randomBite)
                                }
                            }
                        }
                    }
                } else {
                    bites = this.randomlySplit(wordNeedsSpelling);
                    if (type.startsWith("pop")) {
                        for (let i = 1; i < randomCards.length; i++) {
                            bites.push(this.randomlySplit(type.indexOf("-term") > -1 ? randomCards[i].definition : randomCards[i].term )[0]);
                        }
                    }
                }
            }

            let patternConfig = {}

            if (type.startsWith("connect")) {
                const size =  wordNeedsSpelling.length < 10 ? 3 : wordNeedsSpelling.length < 17 ? 4 : 5;
                const maxIndex = size*size-1;
                let layout = Array(size*size);
                let route = [];

                let correctRoute = false;
                let routeI = 0;
   
                while (!correctRoute) {
                    let nthChar = 0;
                    route = [Utilities.randomIntFromInterval(0, maxIndex)];
                    layout = Array(size*size);
                    layout[route[0]] = charsToSpell[nthChar];

                    // console.log(route[0] + " is " + charsToSpell[0])

                    let nextI = null;
                    for (let i = 1; i < charsToSpell.length; i++) {

                        // console.log(i + " / " + charsToSpell.length)

                        const prevI = route[i-1];
                        nextI = null;

                        let nextIPossibilities = this.getPossiblePatternPosition(size, prevI)

                        nextIPossibilities = Utilities.shuffle(nextIPossibilities);
                        for (let j = 0; j < nextIPossibilities.length; j++) {
                            let possible = nextIPossibilities[j];
                            if (!layout[possible]) {
                                // console.log(" __ " + possible + " is possible")
                                nextI = possible
                                break;
                            } else {
                                // console.log(" __ " + possible + " is NOT possible")
                            }
                        }

                        if (nextI !== null) {
                            // console.log(charsToSpell[i] + " is PUT INTO " + nextI)
                            route.push(nextI);
                            layout[nextI] = charsToSpell[i];
                            continue;
                        }

                        break
                    }

                    if (route.length === charsToSpell.length) {
                        // console.log("FOUND PATH @ " + routeI + " try")
                        correctRoute = true;
                    } else {
                        //console.log("@@ Dead end with ", route, layout)
                    }

                    routeI++;
                    if (!correctRoute && routeI === 100) {
                       console.log("@ Too many tries for " + wordNeedsSpelling + " ", route);
                        correctRoute = true
                    }
                }

                let possibleRandomLetters = "abcdefghijklmnopqrstuvwxyz ";

                for (let i = 0; i < charsToSpell.length; i++) {
                    possibleRandomLetters = possibleRandomLetters.replace(charsToSpell[i], "")
                }

                for (let i = 0; i < layout.length; i++) {
                    if (!layout[i]) {
                        layout[i] = Utilities.randomStr(1, possibleRandomLetters || " ")
                    }
                }

                patternConfig = {
                    size: size,
                    layout: layout,
                    route: route
                }
            }

            if (type.startsWith("pop")) {
                for (let i = 0; i < bites.length; i++) {
                    let bite = {}
                    bite.text = bites[i];
                    let isNotOverlapping = false;
                    let overlapCheckI = 0;
                    // console.log("______" + overlapCheckI)

                    const BITE_SIZE = 56;

                    const MAX_LEFT = document.body.clientWidth > 500 ? 500 : document.body.clientWidth
    
                    while (!isNotOverlapping) {
                        overlapCheckI++;
                        const thisTop = Utilities.randomIntFromInterval(0, 340 - BITE_SIZE);
                        const thisLeft = Utilities.randomIntFromInterval(15, MAX_LEFT - 15 - BITE_SIZE);
    
                        let hasOverlapThisRound = false;
                        for (let j = 0; j < i; j++) {
                            const thatTop = bites[j].top;
                            const thatLeft = bites[j].left;
    
                            function touches(a, b) {
                                if (a.x1 > b.x2 || b.x1 > a.x2) return false;
                                if (a.y1 > b.y2 || b.y1 > a.y2) return false;
                                return true;
                            }
    
                            if (touches({
                                x1: thisTop,
                                y1: thisLeft,
                                x2: thisTop + BITE_SIZE,
                                y2: thisLeft + BITE_SIZE,
                            }, {
                                x1: thatTop,
                                y1: thatLeft,
                                x2: thatTop + BITE_SIZE,
                                y2: thatLeft + BITE_SIZE,
                            })) {
                                hasOverlapThisRound = true;
                            }
    
                            if (hasOverlapThisRound) {
                                break;
                            }
                        }
    
                        if (overlapCheckI === 30 || !hasOverlapThisRound) {
                            bite.top = thisTop;
                            bite.left = thisLeft;
                            if (overlapCheckI === 50) {
                                console.log("@@@@ TOO MUCH")
                                // bite.top = -100
                                // bite.left = -100
                            } else {
                                // if (overlapCheckI > 30)
                                // console.log("@@@@ FOUND AT " + overlapCheckI)
                            }
                            isNotOverlapping = true;
                        }
                    }
                    bites[i] = bite;
                }   
            }

            let shuffledCards = (type.indexOf("-term") > -1) ? Utilities.shuffle([randomCards[0].definition, randomCards[1].definition, randomCards[2].definition, randomCards[3].definition]) :
                Utilities.shuffle([randomCards[0].term, randomCards[1].term, randomCards[2].term, randomCards[3].term]);

            return {
                options: shuffledCards,
                bites: Utilities.shuffle(bites),
                pattern: patternConfig
            }

        }

        return null;

    }

    async compileRounds() {
        let rounds = [];
        let possibleTypes = this.state.practiceTypes;

        if (this.state.cards) {
            for (var i = 0; i < this.state.cards.length; i++) {
                let type = this.getRandomType(possibleTypes, this.state.cards[i].term, (this.state.cards[i].setTerm && window.globalVars.availableLanguages.indexOf(this.state.cards[i].setTerm) > -1), this.state.cards[i].definition, (this.state.cards[i].setDefinition && window.globalVars.availableLanguages.indexOf(this.state.cards[i].setDefinition) > -1))
                let options = this.getOptions(i, type, this.state.cards);
                let round = {
                    type: type,
                    cards: [this.state.cards[i]],
                    options: options ? options.options : null,
                    bites: options ? options.bites : null,
                    success: [],
                    pattern: options ? options.pattern : null
                }
                rounds.push(round)
                rounds.push(null)
            }
    
            this.setState({
                rounds: rounds.map((item, i) => {
                    if (item)
                        item.originalI = i
                    return item;
                })
            }, () => {
                this.swiperRef.current.swiper().slideTo(this.state.currentRound, 300);
                this.onQuestionInit(this.state.currentRound);
            })
        }

    }

    savePracticeConfig = async () => {
        let lastPractice = await Storage.getO("lastPractice");
        if (lastPractice) {
            let practiceConfig = this.state.practiceConfig;
            practiceConfig.currentCard = this.state.currentCard;
            Storage.setO("lastPractice", practiceConfig);
        }
    }

    async load() {

        if (isPlatform("ios")) {
            Keyboard.setResizeMode({mode:"native"})
        }

        let lastPractice = await Storage.getO("lastPractice");
        let cards = [];
        let studyset;
        let setsRedux;

        if (lastPractice && lastPractice.type === "quiz") {

            let currentCard = 0;

            if (!lastPractice.cardIds || lastPractice.cardIds.length === 0) {

                if (lastPractice.uninited) {
                    cards = JSON.parse(localStorage.getItem("uninitedPractice"));
                } else if (lastPractice.content === "due") {
                    cards = await SQLStorage.getDueCards(Utilities.timestamp());
                } else if (lastPractice.content === "new") {
                    cards = await SQLStorage.getNewCards();
                } else if (lastPractice.content === "mastered" || lastPractice.content === "learnt" || lastPractice.content === "studying") {
                    cards = await SQLStorage.getCardsByStregth(lastPractice.content === "mastered" ? 5 : lastPractice.content === "learnt" ? 3 : 1 );
                } else {
                    cards = await SQLStorage.getAllCardsFromStudyset(lastPractice.content === "custom" ? null : lastPractice.content, "lastReviewed", "ASC");
                    cards = Utilities.filterForPractice(cards, lastPractice.filters.filter(f => !f.startsWith("keywords:")), lastPractice.filters.find(f => f.startsWith("keywords:")) ? lastPractice.filters.find(f => f.startsWith("keywords:")).replace("keywords:", "") : null);
                    studyset = await SQLStorage.getStudyset(lastPractice.content === "custom" ? cards[0].setId : lastPractice.content);
                    if (!studyset) {
                        store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.setNotFound, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
                    }
                }

                cards = cards.filter(item => item.term && item.definition);
                // Removing unusable cards
    
                if (lastPractice.total !== lastPractice.chunk) {
                    cards = cards.slice(0 + lastPractice.chunkI * lastPractice.chunk, (0 + lastPractice.chunkI * lastPractice.chunk) + lastPractice.chunk)
                }

            } else {

                if (lastPractice.uninited) {
                    cards = JSON.parse(localStorage.getItem("uninitedPractice"));
                    currentCard = lastPractice.currentCard;
                } else {
                    cards = await SQLStorage.getCardsByIds(lastPractice.cardIds, true);
                    currentCard = lastPractice.currentCard;
                }

            }

            if (!studyset && !lastPractice.uninited) {
                setsRedux = store.getState().calendar.studysets;
                if (!setsRedux) {
                    setTimeout(function() { this.load() }.bind(this), 100);
                    return;
                }
            }

            if (studyset) {
                for (let i = 0; i < cards.length; i++) {
                    if (lastPractice.content === "custom") {
                        studyset = store.getState().calendar.studysets[cards[i].setId];
                    }
                    cards[i].setTerm = studyset.term || "";
                    cards[i].setDefinition = studyset.definition || "";
                    console.log(cards[i].termLanguage + " " + cards[i].definitionLanguage)
                }
            } else if (!lastPractice.uninited) {
                for (let i = 0; i < cards.length; i++) {
                    cards[i].setTerm = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].term) ? setsRedux[cards[i].setId].term : ""
                    cards[i].setDefinition = (setsRedux[cards[i].setId] && setsRedux[cards[i].setId].definition) ? setsRedux[cards[i].setId].definition : ""
                }
            }

            if (cards.length < 10) {
                store.dispatch(updatedSetsSet(['null'])); await Storage.remove("lastPractice"); window.toast(window.ln.notEnoughCards, "error"); this.props.history.goBack(); this.setState({ fullscreenLoading: false }); return;
            }

            let tags = lastPractice.uninited ? [] : (await SQLStorage.getTags());

            this.setState({
                details: studyset,
                cards: cards,
                tags: tags,
                fullscreenLoading: false,
                currentRound: currentCard,
                practiceConfig: lastPractice
            }, async () => {
                Utilities.trackEvent("Quiz", "Quiz Practice Start", lastPractice.content, this.state.currentRound);
                if (lastPractice.configuredPracticeTypes) {
                    this.compileRounds();
                } else {
                    let practiceConfig = this.state.practiceConfig
                    if (!practiceConfig.cardIds || practiceConfig.cardIds.length === 0) {
                        practiceConfig.cardIds = this.state.cards.map(item => item.id);
                    }
                    practiceConfig.configuredPracticeTypes = true;
                    this.setState({ practiceConfig: practiceConfig }, () => { this.savePracticeConfig() })
                }
            })

        } else {

            this.props.history.push('/sets');

        }

    }

    savePracticeConfig = async () => {
        let lastPractice = await Storage.getO("lastPractice");
        if (lastPractice) {
            let practiceConfig = this.state.practiceConfig;
            practiceConfig.currentCard = this.state.currentRound % 2 === 0 ? this.state.currentRound : this.state.currentRound+1; // && this.state.currentRound % 2 === 0 ? Math.floor(this.state.currentRound / 2) : 0;
            Storage.setO("lastPractice", practiceConfig);
        }
    }

    async ionViewWillEnter() {
        let deviceInfo = await Device.getInfo();
        this.setState({ platform: deviceInfo.platform });
        this.load();
    }

    componentWillUnmount() {
        Keyboard.setResizeMode({mode:"body"})
        this.setState({
            rounds: []
        })
    }

    // Handle Repeat, skip wiht localstoraoge card ids, maybe restore results

    passToNextQuestion(success, goingToBeReview) {

        this.setState({
            currentRound: (this.swiperRef.current.swiper().activeIndex + 1) ? (this.swiperRef.current.swiper().activeIndex + 1) : this.state.currentRound
        }, async function() {
            this.savePracticeConfig();
            this.swiperRef.current.swiper().slideTo(this.state.currentRound, 300);
            this.clickBlocked = false;
            if (this.state.currentRound !== this.state.rounds.length) {
                if (goingToBeReview) {

                    this.hitNextBtnManually = false;

                    const i = this.state.currentRound ? Math.floor(this.state.currentRound / 2) : 0
                    let prevTypeInput = document.querySelector('#type-input-' + i);
                    if (prevTypeInput && prevTypeInput.childNodes[0]) {
                        prevTypeInput.childNodes[0].value = ""
                        prevTypeInput.childNodes[0].blur();
                    }

                    let timeout = (this.state.timeoutAfterError && !success) ? this.state.timeoutAfterError :
                        (this.state.timeoutAfterCorrect && success) ? this.state.timeoutAfterCorrect :
                        0;

                    const hadOriginalTimeout = timeout !== 0;

                    console.log("@@@@ Original TIMEOUT " + timeout)

                    const startTime = performance.now();

                    if (this.state.pronounceTermOnReview) {
                        await this.pronounceTerm();
                    }

                    if (this.state.pronounceDefinitionOnReview && !this.hitNextBtnManually) {
                        await this.pronounceDefinition();
                    }

                    const endTime = performance.now();

                    let timeDiff = Math.round((endTime - startTime) / 1000);

                    console.log("@@@@ TIME TO PRONOUNCE " + timeDiff)

                    if (this.hitNextBtnManually) {
                        console.log("@@RET")
                        return;
                    }

                    if (hadOriginalTimeout) {
                        timeout = timeout - timeDiff;

                        console.log("@@@@ STILL HAVE THIS TIMEOUT " + timeout)

                        this.setState({
                            nextQuestionTimeout: timeout
                        })

                        this.nextQuestionTimeout = setTimeout(() => {
                            let el = document.getElementById("next-question-btn");
                            if (el) el.click();
                        }, timeout > 0 ? timeout * 1000 : 0);
                    } 

                } else {
                    this.onQuestionInit(this.state.currentRound);
                    if (!window.dark) {
                        this.setState({
                            backgroundColor: BACKGROUND_COLORS[Utilities.randomIntFromInterval(0, BACKGROUND_COLORS.length-1)]
                        })
                    }
                }
            }
        })

    }

    async pronounce() {

        let question = this.state.rounds[this.state.currentRound];

        if (question.type.indexOf("term") !== -1) {
            await Utilities.pronounceWord(question.cards[0].term, question.cards[0].setTerm);
        } else if (question.type.indexOf("definition") !== -1) {
            await Utilities.pronounceWord(question.cards[0].definition, question.cards[0].setDefinition);
        }

    }

    async pronounceTerm() {
        let question = (this.state.rounds && this.state.currentRound) && (this.state.rounds[this.state.currentRound] || this.state.rounds[this.state.currentRound-1]);
        if (question && question.cards[0].setTerm && window.globalVars.availableLanguages.indexOf(question.cards[0].setTerm) > -1) {
            let res = await Utilities.pronounceWord(question.cards[0].term, question.cards[0].setTerm);
            console.log(res);
        }
    }

    async pronounceDefinition() {
        let question = (this.state.rounds && this.state.currentRound) && (this.state.rounds[this.state.currentRound] || this.state.rounds[this.state.currentRound-1]);
        if (question && question.cards[0].setDefinition && window.globalVars.availableLanguages.indexOf(question.cards[0].setDefinition) > -1) {
            let res = await Utilities.pronounceWord(question.cards[0].definition, question.cards[0].setDefinition);
            console.log(res);
        }
    }

    onQuestionInit(currentRound) {

        console.log("@@@@@@ INITINQ UESTION ", currentRound)

        const currentRoundI = currentRound ? Math.floor(currentRound / 2) : 0;

        if (!this.state.rounds[this.state.currentRound]) {
            console.error("No roud found");
            return;
        }
    
        if (this.state.rounds[this.state.currentRound].type.indexOf("pronounce") !== -1) {
            this.pronounce();
        }

        this.lastHandledDigit = null;

        if (this.state.rounds[currentRoundI] && this.state.rounds[currentRoundI].type.startsWith("type")) {

            setTimeout(function() {
                let nextTypeInput = document.querySelector('#type-input-' + currentRoundI);
                console.log(currentRoundI, nextTypeInput)
                if (nextTypeInput && nextTypeInput.childNodes[0]) {
                    nextTypeInput.childNodes[0].value = "";
                    nextTypeInput.childNodes[0].focus();
                }
            }.bind(this), 350)

        }

        if (this.state.rounds[this.state.currentRound] && this.state.rounds[this.state.currentRound].type.startsWith("connect")) {
            this.setState({
                inRoundPatternPath: [this.state.rounds[this.state.currentRound].pattern.route[0]]
            });
            console.log(".swiper-slide[data-i='" + currentRoundI + "'] .react-pattern-lock__pattern-wrapper")
            console.log(document.querySelector(".swiper-slide[data-i='" + currentRoundI + "'] .react-pattern-lock__pattern-wrapper"))
            let patternWrapper = document.querySelector(".swiper-slide[data-i='" + currentRoundI + "'] .react-pattern-lock__pattern-wrapper");
            let letterWrapper = document.querySelector(".swiper-slide[data-i='" + currentRoundI + "'] .letters");
            let wholeWrapper = document.querySelector(".swiper-slide[data-i='" + currentRoundI + "'] .connect-wrapper");
            let hint = document.querySelector(".swiper-slide[data-i='" + currentRoundI + "'] .hint");
            if (patternWrapper && letterWrapper) {
                letterWrapper.style.width = patternWrapper.clientWidth + "px"
                letterWrapper.style.height = patternWrapper.clientWidth + "px"
                wholeWrapper.style.width = patternWrapper.clientWidth + "px"
                wholeWrapper.style.height = patternWrapper.clientWidth + "px"
                hint.style.height = 'calc(100% - ' + (patternWrapper.clientWidth + 80) + 'px)'
            }
        }

        this.setState({
            inRoundMistakesBuffer: 0,
            inRoundTextBuffer: "",
            incorrectPatternI: null,
        })

    }

    onMatchClick(givenAnswer, i) {

        if (givenAnswer === "")
            return

        let rounds = this.state.rounds;
        let question = rounds[this.state.currentRound];
        question.optionsState = question.optionsState || ["", "", "", "", "", "", "", "", "", "", "", ""]
        let markedLocation = question.optionsState.indexOf("marked");

        if (markedLocation > -1) {
            if (markedLocation === i) {
                question.optionsState[i] = "";
                rounds[this.state.currentRound] = question;
                this.setState({ rounds: rounds })
            } else {
                this.checkAnswer(markedLocation, i);
            }
        } else {
            question.optionsState[i] = "marked";
            rounds[this.state.currentRound] = question;
            this.setState({ rounds: rounds })
        }

    }

    async checkAnswer(givenAnswer, givenAnswerPair) {

        if (this.clickBlocked)
            return

        this.clickBlocked = true;

        let rounds = this.state.rounds;
        let question = rounds[this.state.currentRound];

        let success = false;
        let correctAnswer = givenAnswer;

        console.log("CHECKING ANSWER FOR: " + this.state.currentRound)

        if (question.type.indexOf("term") > -1) {
            if (question.cards[0].definition === givenAnswer) success = true;
            else correctAnswer = question.cards[0].definition
        } else if (question.type.indexOf("definition") > -1) {
            if (question.cards[0].term === givenAnswer) success = true;
            else correctAnswer = question.cards[0].term
        }

        question.success = [success]
        question.result = {
            correctAnswer: correctAnswer,
            givenAnswer: givenAnswer,
        }

        rounds[this.state.currentRound] = question;

        Utilities.trackEvent("Quiz", "Quiz Answer", question.type, success === true ? 1 : 0);

        this.saveActivity(question.cards[0].id, question.type, success);

        this.setState({
            rounds: rounds,
            incorrectPatternI: null
        }, () => {
            this.setState({
                inRoundMistakesBuffer: 0,
                inRoundTextBuffer: "",
                inRoundPatternPath: [],
            })
    
            this.passToNextQuestion(success, true);
            this.clickBlocked = false;
        })

    }

    async saveActivity(cardId, type, result) {
        if (this.state.practiceConfig.uninited) {
            return;
        }

        let card = await SQLStorage.getCardById(cardId);
        card.history.push(type + "_" + (result ? 1 : 0) + "_" + Utilities.timestamp());
        await SQLStorage.saveCard(card);
        await window.dropbox.queueForUpload("card", card.id + "-" + card.setId);
    }

    async endPractice(continueLater) {
        if (this.state.practiceConfig.uninited && continueLater === undefined) {
            this.endPractice(false);
            return;
        }

        Utilities.trackEvent("Quiz", "Quiz Practice End", null, continueLater ? 1 : 0);
        
        if (continueLater === undefined) {
            this.setState({
                endPracticeConfirm: true
            })
        } else {
            if (!continueLater) {
                await Storage.remove("lastPractice");
                localStorage.setItem("justEndedPractice", "true");
            }
            this.setState({ rounds: null, currentRound: null })
            store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
            this.props.history.goBack();
        }
    }

    repeatThisChunk = async () => {
        Utilities.trackEvent("Quiz", "Quiz Repeat this Round");
        store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
        this.setState({
            currentRound: 0,
            currentTypeAnswer: "",
        }, () => {
            this.compileRounds();
            this.swiperRef.current.swiper().slideTo(0, 300);
        })
    }

    loadNextChunk = async () => {
        Utilities.trackEvent("Quiz", "Quiz Load next Round");
        store.dispatch(updatedSetsSet([...new Set(this.state.cards.map(c => c.setId))]))
        let practiceConfig = this.state.practiceConfig;
        practiceConfig.cardIds = [];
        this.setState({
            currentRound: 0,
            practiceConfig: practiceConfig
        }, async () => {
            await this.savePracticeConfig();
            this.load();
            this.swiperRef.current.swiper().slideTo(0, 300);
        })
    }

    render() {

        const progressBarMaxWidth = this.progressBar.current ?  (this.progressBar.current.clientWidth - 10) : 0;

        const closeBtn = <IonIcon icon={closeCircle} onClick={() => { this.endPractice() }} className="close-practice-btn"></IonIcon>

        return (
            <IonPage data-page="practice" id="practice-ion-page">
                <IonHeader>
                    <IonToolbar style={ (!this.state.rounds) ? { '--background': 'initial', height: 'initial' } : { '--background': this.state.backgroundColor }}>
                        { (!this.state.rounds) &&
                            <React.Fragment>
                                <IonTitle>{window.ln.selectQuizTypes}</IonTitle>
                                <IonButtons slot="end">
                                    <IonIcon icon={close} onClick={ async () => {
                                        this.endPractice();
                                    }} />
                                </IonButtons>
                            </React.Fragment>
                        }
                    </IonToolbar>
                </IonHeader>
                <IonContent data-onboarding="false" style={ !this.state.rounds ? { } : { '--overflow': 'hidden' }}>
                    { (!this.state.rounds) &&
                        <div className='practice-options'>
                            <section>
                                {[
                                    ["drag-select-term", "drag-select-definition", "drag-pronounce-term", "drag-pronounce-definition"],
                                    ["pop-select-term", "pop-select-definition", "pop-pronounce-term", "pop-pronounce-definition"],
                                    ["connect-select-term", "connect-select-definition", "connect-pronounce-term", "connect-pronounce-definition"],
                                    // ["type-term", "type-definition", "type-pronounce-term", "type-pronounce-definition"]
                                ].map((typeSectionGroup, typeSectionGroupI) => {
                                    return (
                                        <div 
                                            className='group'
                                            style={{ background: typeSectionGroupI === 0 ? "#4D80E4" : typeSectionGroupI === 1 ? "#00B383" : "#C361F8" }}
                                        >
                                            <img src={typeSectionGroupI === 0 ? PracticeMultichoiceImg : typeSectionGroupI === 1 ? PracticeConnectImg : typeSectionGroupI === 2 ? PracticePatternImg : null} />
                                            <div>
                                                { typeSectionGroup.map(practiceType => {
                                                    let from = practiceType.indexOf("term") > practiceType.indexOf("definition") ? window.ln.term : window.ln.defShort;
                                                    let to = practiceType.indexOf("term") > practiceType.indexOf("definition") ? window.ln.defShort : window.ln.term;
                                                    return (
                                                        <div 
                                                            className='practice-type' 
                                                            data-selected={this.state.practiceTypes.indexOf(practiceType) !== -1}
                                                            onClick={ async () => {
                                                                let practiceTypes = this.state.practiceTypes;
                                                                let loc = practiceTypes.indexOf(practiceType);
                                                                if (loc === -1) {
                                                                    practiceTypes.push(practiceType)
                                                                } else {
                                                                    practiceTypes.splice(loc, 1);
                                                                }

                                                                this.setState({
                                                                    practiceTypes: practiceTypes,
                                                                    hasChangedPracticeTypes: true
                                                                });
                                                            }}
                                                        >
                                                            <div className='def'>
                                                                <IonIcon icon={ practiceType.indexOf("pronounce") !== -1 ? headset : textOutline} />
                                                                <span>{from}</span>
                                                            </div>
                                                            <div className='checkbox'>
                                                                <IonIcon icon={ this.state.practiceTypes.indexOf(practiceType) !== -1 ? checkboxOutline : squareOutline } />
                                                            </div>
                                                        </div>
                                                    )
                                                }) }
                                            </div>
                                        </div>
                                    )
                                }) }
                            </section>   
                            { this.state.practiceConfig && !this.state.practiceConfig.uninited &&                   
                                <section>
                                    <div>
                                        <IonList>
                                            <IonItem>
                                                <IonLabel>{window.ln.reviewTimeError}</IonLabel>
                                                <IonSelect 
                                                    onIonChange={ async (i) => {
                                                        this.setState({ timeoutAfterError: parseInt(i.detail.value) });
                                                        await SQLStorage.saveSetting("timeoutAfterError", i.detail.value)
                                                        await window.dropbox.queueForUpload("setting", "timeoutAfterError");
                                                        store.dispatch(updatedSetsSet(['null']))
                                                        window.dropbox.debounce(true);
                                                    }} 
                                                    value={this.state.timeoutAfterError}
                                                >
                                                    { [
                                                        {sec: 0, label: 'Manual Next' },
                                                        {sec: 2, label: '2 second' },
                                                        {sec: 4, label: '4 second' },
                                                        {sec: 6, label: '6 second' },
                                                        {sec: 8, label: '8 second' },
                                                        {sec: 10, label: '10 second' }
                                                    ].map((item, i) => {
                                                        return (
                                                            <IonSelectOption key={item.sec} value={item.sec} >
                                                                {item.label}
                                                            </IonSelectOption>
                                                        )
                                                    }) }
                                                </IonSelect>
                                            </IonItem>
                                            <IonItem>
                                                <IonLabel>{window.ln.reviewTimeCorrect}</IonLabel>
                                                <IonSelect 
                                                    onIonChange={ async (i) => {
                                                        this.setState({ timeoutAfterCorrect: parseInt(i.detail.value) });
                                                        await SQLStorage.saveSetting("timeoutAfterCorrect", i.detail.value)
                                                        await window.dropbox.queueForUpload("setting", "timeoutAfterCorrect");
                                                        store.dispatch(updatedSetsSet(['null']))
                                                        window.dropbox.debounce(true);
                                                    }} 
                                                    value={this.state.timeoutAfterCorrect}
                                                >
                                                    { [
                                                        {sec: 0, label: 'Manual Next' },
                                                        {sec: 2, label: '2 second' },
                                                        {sec: 4, label: '4 second' },
                                                        {sec: 6, label: '6 second' },
                                                        {sec: 8, label: '8 second' },
                                                        {sec: 10, label: '10 second' }
                                                    ].map((item, i) => {
                                                        return (
                                                            <IonSelectOption key={item.sec} value={item.sec} >
                                                                {item.label}
                                                            </IonSelectOption>
                                                        )
                                                    }) }
                                                </IonSelect>
                                            </IonItem>
                                            <IonItem>
                                                <IonLabel>{window.ln.pronounceTermAfterReview}</IonLabel>
                                                <IonSelect 
                                                    onIonChange={ async (i) => {
                                                        this.setState({ pronounceTermOnReview: i.detail.value });
                                                        await SQLStorage.saveSetting("pronounceTermOnReview", i.detail.value)
                                                        await window.dropbox.queueForUpload("setting", "pronounceTermOnReview");
                                                        store.dispatch(updatedSetsSet(['null']))
                                                        window.dropbox.debounce(true);
                                                    }} 
                                                    value={this.state.pronounceTermOnReview}
                                                >
                                                    { [
                                                        {sec: "true", label: window.ln.yes },
                                                        {sec: "false", label: window.ln.no }
                                                    ].map((item, i) => {
                                                        return (
                                                            <IonSelectOption key={item.sec} value={item.sec} >
                                                                {item.label}
                                                            </IonSelectOption>
                                                        )
                                                    }) }
                                                </IonSelect>
                                            </IonItem>
                                            <IonItem>
                                                <IonLabel>{window.ln.pronounceDefinitionAfterReview}</IonLabel>
                                                <IonSelect 
                                                    onIonChange={ async (i) => {
                                                        this.setState({ pronounceDefinitionOnReview: i.detail.value });
                                                        await SQLStorage.saveSetting("pronounceDefinitionOnReview", i.detail.value)
                                                        await window.dropbox.queueForUpload("setting", "pronounceDefinitionOnReview");
                                                        store.dispatch(updatedSetsSet(['null']))
                                                        window.dropbox.debounce(true);
                                                    }} 
                                                    value={this.state.pronounceDefinitionOnReview}
                                                >
                                                    { [
                                                        {sec: "true", label: window.ln.yes },
                                                        {sec: "false", label: window.ln.no }
                                                    ].map((item, i) => {
                                                        return (
                                                            <IonSelectOption key={item.sec} value={item.sec} >
                                                                {item.label}
                                                            </IonSelectOption>
                                                        )
                                                    }) }
                                                </IonSelect>
                                            </IonItem>
                                        </IonList>
                                    </div>
                                </section>
                            }
                            { (this.state.nonBlockingError) &&
                                <div 
                                    className="info-banner"
                                    style={{
                                        marginBottom: 15
                                    }}
                                >
                                    <IonIcon icon={informationCircleSharp} />
                                    <label>
                                        {this.state.nonBlockingError}
                                    </label>
                                </div>
                            }
                            <button 
                                className='default' 
                                onClick={async () => {
                                    this.compileRounds();
                                    if (this.state.hasChangedPracticeTypes && this.state.practiceConfig && !this.state.practiceConfig.uninited) {
                                        await SQLStorage.saveSetting("practiceTypesV2", this.state.practiceTypes.join(","))
                                        await window.dropbox.queueForUpload("setting", "practiceTypesV2");
                                        store.dispatch(updatedSetsSet(['null']))
                                        window.dropbox.debounce(true);
                                    }
                                    Utilities.trackEvent("Quiz", "Quiz Practice Config", this.state.practiceTypes.join(",") + "|" + this.state.timeoutAfterError + "|" + this.state.timeoutAfterCorrect + "|" + this.state.pronounceTermOnReview + "|" + this.state.pronounceDefinitionOnReview);
                                }}
                            >
                                {window.ln.startPractice}
                            </button>
                        </div>
                    }
                    { (this.state.rounds) &&
                        <div className="practice-container">
                            <div className="swiper-wrapper-top">
                                <Swiper
                                       swiperOptions={{
                                           slidesPerView: 'auto',
                                           direction: 'horizontal',
                                           noSwipingClass: 'no-swipe',
                                           noSwiping: true
                                       }}
                                       ref={this.swiperRef}
                                       onTransitionEnd={(swiper) => {

                                       }}
                                       style={{ 'background': this.state.backgroundColor }}
                                     >
                                       {this.state.rounds.map((question, slideI) => {

                                            const i = slideI ? Math.floor(slideI / 2) : 0

                                           if (!question) {
                                                let currentQuestion = this.state.rounds[slideI-1];

                                                return <Slide className="no-swipe" data-i={i + 100} key={"result-" + i}>
                                                    <div className='solution-card-wrapper'>
                                                        <div 
                                                            className='solution-card'
                                                            style={{ 'background': this.state.backgroundColor }}
                                                        >
                                                            {closeBtn}
                                                            <div>
                                                                <div className='header-2'>
                                                                    <div 
                                                                        className='progress-bar'
                                                                        ref={this.progressBar}
                                                                    >
                                                                        { (this.progressBar.current && this.state.practiceConfig && this.state.practiceConfig.cardIds) &&
                                                                            <React.Fragment>
                                                                                <div 
                                                                                    className='current'
                                                                                    style={{
                                                                                        width: (i / this.state.practiceConfig.cardIds.length * progressBarMaxWidth),
                                                                                        background: this.state.backgroundColor
                                                                                    }}
                                                                                >
                                                                                    {/* { this.state.rounds.filter(item => item !== null).map((item, itemI) => {
                                                                                        if (item && item.result && item.result.givenAnswer !== item.result.correctAnswer)
                                                                                            return (
                                                                                                <span 
                                                                                                    className='error'
                                                                                                    style={{
                                                                                                        left: ((itemI) / this.state.practiceConfig.cardIds.length * progressBarMaxWidth),
                                                                                                        width: (1 / this.state.practiceConfig.cardIds.length * progressBarMaxWidth)
                                                                                                    }}
                                                                                                ></span>
                                                                                            )
                                                                                        return null;
                                                                                    }) } */}
                                                                                </div>
                                                                            </React.Fragment>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {/* <div className='header'>
                                                                    <div>
                                                                        { this.state.rounds.map((questionRound, questionI) => {
                                                                            if (!questionRound)
                                                                                return null;

                                                                            return (
                                                                                <div className='result' data-success={questionRound.result && (questionRound.result && questionRound.result.givenAnswer === questionRound.result.correctAnswer)} data-error={questionRound.result && (questionRound.result && questionRound.result.givenAnswer !== questionRound.result.correctAnswer)} >
                                                                                    { !questionRound.result &&
                                                                                        <IonIcon icon={ellipse} />
                                                                                    }
                                                                                    { !questionRound.result &&
                                                                                        <label>{(questionI ? Math.floor(questionI / 2) : 0) + 1}</label>
                                                                                    }
                                                                                    { (questionRound.result && questionRound.result.givenAnswer === questionRound.result.correctAnswer) &&
                                                                                        <IonIcon className="success" icon={checkmark} />
                                                                                    }
                                                                                    { (questionRound.result && questionRound.result.givenAnswer !== questionRound.result.correctAnswer) &&
                                                                                        <IonIcon className="error" icon={close} />
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }) }
                                                                    </div>
                                                                </div> */}
                                                                { (currentQuestion && currentQuestion.result && currentQuestion.cards) &&
                                                                    <div className='body'>
                                                                        <div 
                                                                            className='res'
                                                                            data-success={currentQuestion.result.givenAnswer === currentQuestion.result.correctAnswer}
                                                                        >
                                                                            <IonIcon icon={ currentQuestion.result.givenAnswer === currentQuestion.result.correctAnswer ? checkmarkCircle : closeCircle } />
                                                                            <span>{currentQuestion.result.givenAnswer === currentQuestion.result.correctAnswer ? window.ln.correct : window.ln.incorrect}</span>
                                                                        </div>
                                                                        <div className='term'>{ currentQuestion.cards[0].term}</div>
                                                                        <div className='definition'>{ currentQuestion.cards[0].definition}</div>
                                                                    </div>
                                                                }
                                                                <div className="controls">
                                                                    {/* <div 
                                                                        onClick={ async () => {
                                                                            this.endPractice();
                                                                        }}
                                                                        className="next-btn"
                                                                    >
                                                                        <IonIcon icon={close} />
                                                                        {window.ln.close}
                                                                    </div> */}
                                                                    {/* { !(i === 0 || slideI + 1 === this.state.rounds.length) &&
                                                                        <div
                                                                            className="next-btn"
                                                                            onClick={e => {
                                                                                this.hitNextBtnManually = true;
                                                                                clearInterval(this.nextQuestionTimeout)
                                                                                this.clickBlocked = false;
                                                                                e.stopPropagation();
                                                                                e.preventDefault();
                                                                                let cards = this.state.cards;
                                                                                cards.splice(i, 1);
                                                                                let rounds = this.state.rounds;
                                                                                rounds.splice(i, 2);
                                                                                this.setState({
                                                                                    cards: cards,
                                                                                    rounds: rounds,
                                                                                    currentRound: this.state.currentRound - 2
                                                                                }, () => {
                                                                                    this.swiperRef.current.swiper().slideTo(this.state.currentRound, 300);
                                                                                    setTimeout(() => {
                                                                                        if (this.state.cards.length === 0) {
                                                                                            this.loadNextChunk();
                                                                                        } else {
                                                                                            this.passToNextQuestion(); 
                                                                                        }
                                                                                    }, 400)
                                                                                })
                                                                            }}
                                                                        > 
                                                                            {window.ln.hideFromPractice}
                                                                        </div>
                                                                    } */}
                                                                    <div 
                                                                        onClick={() => {
                                                                            this.hitNextBtnManually = true
                                                                            clearInterval(this.nextQuestionTimeout)
                                                                            this.setState({
                                                                                nextQuestionTimeout: null
                                                                            })
                                                                            this.passToNextQuestion(); 
                                                                        }}
                                                                        id="next-question-btn"
                                                                        className="next-btn"
                                                                    >
                                                                        {window.ln.next}
                                                                        { (this.state.nextQuestionTimeout) &&
                                                                            <CountdownCircleTimer
                                                                                isPlaying={true}
                                                                                duration={this.state.nextQuestionTimeout}
                                                                                colors={['#333']}
                                                                                size={36}
                                                                                strokeWidth={4}
                                                                                colorsTime={[10]}
                                                                                >
                                                                                {({ remainingTime }) => <div>{remainingTime}</div>}
                                                                            </CountdownCircleTimer>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </Slide>
                                           }

                                           return (
                                               <Slide className="no-swipe" data-i={i} key={"practice-" + i}>
                                                   { ( (this.state.currentRound/2 + 3 > i) && (this.state.currentRound/2 - 3 < i) ) &&
                                                       <div className="question">
                                                           {closeBtn}
                                                           { (question.type.startsWith("type") && question.cards[0]) &&
                                                               <div data-type="type">
                                                                   { question.type.indexOf("pronounce") !== -1 &&
                                                                        <div className="hint pronounce" onClick={() => { this.pronounce() }}>
                                                                            <IonIcon icon={volumeHigh} />
                                                                        </div>
                                                                    }
                                                                    { question.type.indexOf("pronounce") === -1 &&
                                                                        <div className="hint">{ (question.type.indexOf("-term") !== -1) ? question.cards[0].term : question.cards[0].definition }</div>
                                                                    }

                                                                   <IonInput
                                                                       id={"type-input-" + i}
                                                                       className="type-input"
                                                                       ref={(i === this.state.currentRound) ? this.currentInputRef : null}
                                                                       data-correct={ ( ( (question.result) && (question.result.givenAnswer === question.result.correctAnswer) ) ? "true" : "false" ) }
                                                                       data-error={ ( ( (question.result) && (question.result.givenAnswer !== question.result.correctAnswer) ) ? "true" : "false" ) }
                                                                       onKeyDown={(e, b) => { if (e.keyCode === 13) { this.checkAnswer(e.target.value) } }}
                                                                   />
                                                               </div>
                                                           }
                                                           { (question.type.startsWith("pop")) &&
                                                                <div data-type="pop">
                                                                    { question.type.indexOf("pronounce") !== -1 &&
                                                                        <div className="hint pronounce" onClick={() => { this.pronounce() }}>
                                                                            <IonIcon icon={volumeHigh} />
                                                                        </div>
                                                                    }
                                                                    { question.type.indexOf("select") !== -1 &&
                                                                        <div className="hint">{ (question.type.indexOf("-term") !== -1) ? question.cards[0].term : question.cards[0].definition }</div>
                                                                    }
                                                                    { (this.state.currentRound === slideI) &&
                                                                        <div className='drag-area'>
                                                                            <DragDropContext
                                                                                onDragEnd={(action) => {
                                                                                    console.log(action.destination, action)

                                                                                    if (this.state.inRoundMistakesBuffer > 2) {
                                                                                        return;
                                                                                    }

                                                                                    this.setState({ incorrectPatternI: null })

                                                                                    // if (action.destination && action.destination.droppableId === "droppable-0") {
                                                                                        let selectionI = parseInt(action.source.droppableId.split("-")[1])
                                                                                        let bite = question.bites[selectionI - 1].text;

                                                                                        const proposedBuffer = this.state.inRoundTextBuffer + bite;
                                                                                        if ( (question.type.indexOf("term") > -1 && question.cards[0].definition === proposedBuffer) || (question.type.indexOf("definition") > -1 && question.cards[0].term === proposedBuffer) ) {
                                                                                            this.checkAnswer(proposedBuffer);
                                                                                        } else if ( (question.type.indexOf("term") > -1 && question.cards[0].definition.startsWith(proposedBuffer)) || (question.type.indexOf("definition") > -1 && question.cards[0].term.startsWith(proposedBuffer)) ) {
                                                                                            let newRounds = JSON.parse(JSON.stringify(this.state.rounds));
                                                                                            newRounds[this.state.currentRound].bites.splice(selectionI -1, 1);
                                                                                            this.setState({ 
                                                                                                rounds: newRounds,
                                                                                                inRoundTextBuffer: proposedBuffer
                                                                                            })
                                                                                        } else {
                                                                                            this.setState({
                                                                                                inRoundMistakesBuffer: this.state.inRoundMistakesBuffer + 1,
                                                                                                incorrectPatternI: selectionI-1
                                                                                            }, () => {
                                                                                                if (this.state.inRoundMistakesBuffer > 2) {
                                                                                                    this.checkAnswer(proposedBuffer);
                                                                                                }
                                                                                            })
                                                                                        }
                                                                                    // }
                                                                                }}
                                                                            >
                                                                                <div className='bubble-options'>
                                                                                { question.bites.map((biteObj, biteI) => {
                                                                                    const bite = biteObj.text;
                                                                                    return (
                                                                                        <div>
                                                                                            <Droppable key={"droppable-" + (biteI + 1)} droppableId={"droppable-" + (biteI + 1)} type="PERSON">
                                                                                                {(provided, snapshot) => (
                                                                                                    <div
                                                                                                        ref={provided.innerRef}
                                                                                                        style={{ /*backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey'*/ }}
                                                                                                        {...provided.droppableProps}
                                                                                                    >
                                                                                                        <Draggable draggableId={"draggable-" + (biteI + 1)} index={0}>
                                                                                                            {(provided, snapshot) => {
                                                                                                                if (snapshot.isDragging) {
                                                                                                                    const offset = { x: - document.body.clientWidth * slideI, y: 0 }
                                                                                                                    const x = provided.draggableProps.style.left - offset.x;
                                                                                                                    const y = provided.draggableProps.style.top - offset.y;
                                                                                                                    provided.draggableProps.style.left = x;
                                                                                                                    provided.draggableProps.style.top = y;
                                                                                                                }

                                                                                                                if (snapshot.isDragging && snapshot.isDropAnimating) {
                                                                                                                    provided.draggableProps.style.visibility = "hidden"
                                                                                                                }

                                                                                                                return (
                                                                                                                    <div
                                                                                                                        ref={provided.innerRef}
                                                                                                                        {...provided.draggableProps}
                                                                                                                        {...provided.dragHandleProps}
                                                                                                                    >
                                                                                                                        <p 
                                                                                                                            className='bite'
                                                                                                                            data-error={this.state.incorrectPatternI === biteI}
                                                                                                                            style={{
                                                                                                                                top: biteObj.top,
                                                                                                                                left: biteObj.left
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {bite}
                                                                                                                        </p>
                                                                                                                    </div>
                                                                                                                ) 
                                                                                                            }}
                                                                                                        </Draggable>
                                                                                                    </div>
                                                                                                )}
                                                                                            </Droppable>
                                                                                        </div>
                                                                                    )
                                                                                }) }
                                                                                </div>

                                                                                <div className='result'>
                                                                                    <Droppable droppableId="droppable-0" type="TARGET">
                                                                                        {(provided, snapshot) => (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                style={{ /*backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey'*/ }}
                                                                                                {...provided.droppableProps}
                                                                                                onClick={() => {
                                                                                                    if (question.type.indexOf("pronounce") !== -1) {
                                                                                                            this.pronounce();
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <div>
                                                                                                    <div
                                                                                                        data-correct={ (question.result) && (question.result.correctAnswer === question.result.givenAnswer) }
                                                                                                        data-error={ (question.result) && (question.result.correctAnswer !== question.result.givenAnswer) }
                                                                                                    >
                                                                                                        {((question.type.indexOf("-term") === -1) ? question.cards[0].term : question.cards[0].definition).split("").map((letter, letterI) => {
                                                                                                            const solved = this.state.inRoundTextBuffer.length > letterI
                                                                                                            const lastSolved = this.state.inRoundTextBuffer.length === letterI + 1
                                                                                                            return (
                                                                                                                <span className={solved ? (lastSolved ? "solved last-solved" : "solved") : (letter === " " ? "unsolved space" : "unsolved")}>{solved ? letter : " "}</span>
                                                                                                            )
                                                                                                        })}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </Droppable>
                                                                                </div>

                                                                            </DragDropContext>
                                                                        
                                                                        </div>
                                                                    }
                                                                </div>
                                                           }
                                                           { (question.type.startsWith("connect")) &&
                                                                <div data-type="connect">
                                                                    { question.type.indexOf("pronounce") !== -1 &&
                                                                        <div className="hint pronounce" onClick={() => { this.pronounce() }}>
                                                                            <IonIcon icon={volumeHigh} />
                                                                        </div>
                                                                    }
                                                                    { question.type.indexOf("select") !== -1 &&
                                                                        <div className="hint">
                                                                            <div>
                                                                                { (question.type.indexOf("-term") !== -1) ? question.cards[0].term : question.cards[0].definition }
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    { (this.state.currentRound === slideI) &&
                                                                        <div className='connect-wrapper'>
                                                                            <div className='pattern'>
                                                                                
                                                                                <PatternLock
                                                                                    pointActiveSize={40}
                                                                                    disabled={question.result}
                                                                                    size={question.pattern.size}
                                                                                    onChange={(e => {
                                                                                        if (this.state.inRoundMistakesBuffer > 2) {
                                                                                            return null;
                                                                                        }
                                                                                        
                                                                                        let acceptedPatternSoFar = JSON.parse(JSON.stringify(this.state.inRoundPatternPath));
                                                                                        let newDigit = e[e.length-1];
                                                                                        if (newDigit !== this.lastHandledDigit) {

                                                                                            const lastIndex = this.state.inRoundPatternPath[this.state.inRoundPatternPath.length - 1];
                                                                                            if (lastIndex) {
                                                                                                const possibleMoves = this.getPossiblePatternPosition(question.pattern.size, lastIndex)
                                                                                                console.log(possibleMoves, ": Only possible: ", lastIndex);
                                                                                                if (possibleMoves.indexOf(newDigit) === -1) {
                                                                                                    console.log("Invalid move")
                                                                                                    return;
                                                                                                }
                                                                                            }

                                                                                            this.setState({
                                                                                                incorrectPatternI: null
                                                                                            })

                                                                                            this.lastHandledDigit = newDigit
                                                                                            console.log(question.pattern.route[acceptedPatternSoFar.length] + " " + newDigit)
                                                                                            if (question.pattern.route[acceptedPatternSoFar.length] === newDigit) {
                                                                                                this.setState({
                                                                                                    inRoundPatternPath: acceptedPatternSoFar.concat([newDigit])
                                                                                                }, () => {
                                                                                                    if (this.state.inRoundPatternPath.length === question.pattern.route.length) {
                                                                                                        this.checkAnswer(this.state.inRoundPatternPath.map((patternI) => { return question.pattern.layout[patternI] }).join(""));
                                                                                                    }
                                                                                                })
                                                                                            } else {
                                                                                                this.setState({
                                                                                                    inRoundMistakesBuffer: this.state.inRoundMistakesBuffer + 1,
                                                                                                    incorrectPatternI: newDigit
                                                                                                }, () => {
                                                                                                    if (this.state.inRoundMistakesBuffer > 2) {
                                                                                                        this.checkAnswer(this.state.inRoundPatternPath.map((patternI) => { return question.pattern.layout[patternI] }).join(""));
                                                                                                    }
                                                                                                })
                                                                                            }
                                                                                        }
                                                                                    })}
                                                                                    path={this.state.inRoundPatternPath}
                                                                                    error={false}
                                                                                    onFinish={() => {  }}
                                                                                    connectorThickness={5}
                                                                                    disabled={false}
                                                                                    success={false}
                                                                                />
                                                                            </div>
                                                                            <div className='letters' data-size={question.pattern.size}>
                                                                                { question.pattern.layout.map((letter, letterI) => {
                                                                                    const foundAlready = this.state.inRoundPatternPath.indexOf(letterI) !== -1;
                                                                                    const prevConnectionI = foundAlready ? this.state.inRoundPatternPath.indexOf(letterI) - 1 : null;
                                                                                    const prevConnectionIOther = foundAlready ? this.state.inRoundPatternPath[prevConnectionI] : null;
                                                                                    const currentConnectionI = foundAlready ? this.state.inRoundPatternPath.indexOf(letterI) : null;
                                                                                    const currentConnectionIOther = foundAlready ? this.state.inRoundPatternPath[currentConnectionI] : null;
                                                                                    let positionOfChange = null;
                                                                                    
                                                                                    if (foundAlready !== null && this.state.inRoundPatternPath.indexOf(letterI) > 0) {
                                                                                        positionOfChange = (prevConnectionIOther + 1 === currentConnectionIOther) ? "right" :
                                                                                            (prevConnectionIOther - 1 === currentConnectionIOther) ? "left" :
                                                                                            (prevConnectionIOther <= currentConnectionIOther) ? "bottom" :
                                                                                            "top";
                                                                                        console.log(prevConnectionIOther + " -> " + currentConnectionIOther + " ====> " + positionOfChange)
                                                                                    }

                                                                                    return (
                                                                                        <div 
                                                                                            data-error={this.state.incorrectPatternI === letterI || ( question.result && question.result.correctAnswer !== question.result.givenAnswer && this.state.inRoundPatternPath.indexOf(letterI) !== -1 )}
                                                                                            data-selected={this.state.inRoundPatternPath.indexOf(letterI) !== -1 ? "true" : "false"}
                                                                                            data-correct={ (question.result) && (question.result.correctAnswer === question.result.givenAnswer) && this.state.inRoundPatternPath.indexOf(letterI) !== -1 }
                                                                                        >
                                                                                            {foundAlready && <span className='connector' data-direction={positionOfChange}></span>}
                                                                                            <div>{letter}</div>
                                                                                        </div>
                                                                                    )
                                                                                }) }
                                                                            </div>
                                                                        </div>
                                                                   }
                                                                </div>
                                                            }
                                                           { (question.type.startsWith("drag")) &&
                                                                <div data-type="drag">
                                                                    { ((this.state.currentRound === slideI)) &&
                                                                        <div className='drag-context-wrapper'>
                                                                            <DragDropContext
                                                                                onDragEnd={(action) => {
                                                                                    // if (action.destination && action.destination.droppableId === "droppable-0") {
                                                                                        let selectionI = parseInt(action.source.droppableId.split("-")[1])
                                                                                        this.checkAnswer(question.options[selectionI - 1])
                                                                                    // }
                                                                                }}
                                                                            >
                                                                                { question.options.map((alt, altI) => {
                                                                                    return (
                                                                                        <div>
                                                                                            <Droppable key={"droppable-" + (altI + 1)} droppableId={"droppable-" + (altI + 1)} type="PERSON">
                                                                                                {(provided, snapshot) => (
                                                                                                    <div
                                                                                                        ref={provided.innerRef}
                                                                                                        style={{ /* backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey' */ }}
                                                                                                        {...provided.droppableProps}
                                                                                                    >
                                                                                                        <Draggable draggableId={"draggable-" + (altI + 1)} index={0}>
                                                                                                            {(provided, snapshot) => {

                                                                                                                if (snapshot.isDragging) {
                                                                                                                    const offset = { x: - document.body.clientWidth * slideI, y: 0 }
                                                                                                                    const x = provided.draggableProps.style.left - offset.x;
                                                                                                                    const y = provided.draggableProps.style.top - offset.y;
                                                                                                                    provided.draggableProps.style.left = x;
                                                                                                                    provided.draggableProps.style.top = y;
                                                                                                                }

                                                                                                                if (snapshot.isDragging && snapshot.isDropAnimating) {
                                                                                                                    provided.draggableProps.style.left = "50%"
                                                                                                                    provided.draggableProps.style.top = "50%"
                                                                                                                    provided.draggableProps.style.transform = "translate(-50%, -50%)"
                                                                                                                }
                                                                                                                
                                                                                                                return (
                                                                                                                    <div
                                                                                                                        data-correct={ (question.result) && (question.result.correctAnswer === alt) }
                                                                                                                        data-error={ (question.result) && (question.result.givenAnswer === alt) && (question.result.givenAnswer !== question.result.correctAnswer) }
                                                                                                                        ref={provided.innerRef}
                                                                                                                        {...provided.draggableProps}
                                                                                                                        {...provided.dragHandleProps}
                                                                                                                    >
                                                                                                                        {provided.placeholder}
                                                                                                                        <p className='source'>{alt}</p>
                                                                                                                    </div>
                                                                                                                )
                                                                                                            }}
                                                                                                        </Draggable>
                                                                                                </div>
                                                                                            )}
                                                                                            </Droppable>
                                                                                        </div>
                                                                                    )
                                                                                }) }

                                                                                <Droppable droppableId="droppable-0" type="PERSON">
                                                                                    {(provided, snapshot) => (
                                                                                        <div
                                                                                            ref={provided.innerRef}
                                                                                            style={{ /*backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey'*/ }}
                                                                                            {...provided.droppableProps}
                                                                                            onClick={() => {
                                                                                            if (question.type.indexOf("pronounce") !== -1) {
                                                                                                    this.pronounce();
                                                                                            }
                                                                                            }}
                                                                                        >
                                                                                            <div>
                                                                                                <div>
                                                                                                    {provided.placeholder}
                                                                                                    { question.type.indexOf("pronounce") !== -1 ?
                                                                                                        <div className="pronounce hint">
                                                                                                            <IonIcon icon={volumeHigh} />
                                                                                                        </div> :
                                                                                                        <p className='target'>
                                                                                                            {question.type.indexOf("term") !== -1 ?
                                                                                                                question.cards[0].term : 
                                                                                                                question.cards[0].definition
                                                                                                            }
                                                                                                        </p>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </Droppable>

                                                                            </DragDropContext>
                                                                        </div>
                                                                    }
                                                                </div>
                                                           }
                                                           { (question.type.startsWith("match")) &&
                                                               <div data-type="match">
                                                                   <div className="grid">
                                                                       { question.options.map((alt, i) => {
                                                                           return (<div onClick={() => { this.onMatchClick(alt, i) }} data-status={ (question.optionsState) ? question.optionsState[i] : "" }><p>{alt}</p></div>)
                                                                       }) }
                                                                   </div>
                                                               </div>
                                                           }
                                                       </div>
                                                   }
                                               </Slide>
                                           )
                                       })}
                                    <Slide className="no- swipe">
                                        <div className="question-end quiz-end">
                                            <div className='practice-end-wrapper'>
                                                <h2>{window.ln.practiceCompleted}</h2>
                                                { this.state.practiceConfig &&
                                                    <button
                                                        className='close-btn' 
                                                        onClick={() => {
                                                            this.loadNextChunk();
                                                        }}
                                                    >{(window.ln.loadNextXCards).replace("__ ", "" /*this.state.practiceConfig.chunk*/)}</button>
                                                }
                                                { this.state.practiceConfig &&
                                                    <button 
                                                        className='close-btn' 
                                                        onClick={() => {
                                                            this.repeatThisChunk();
                                                        }}
                                                    >
                                                        {(window.ln.repeatPractice).replace("__ ", "" /* this.state.practiceConfig.chunk*/)}
                                                    </button>
                                                }
                                                <button onClick={ async () => {
                                                    this.endPractice();
                                                }} >
                                                    {window.ln.closePractice}
                                                </button>
                                            </div>
                                        </div>
                                    </Slide>
                               </Swiper>
                            </div>
                        </div>
                    }
                    <IonActionSheet
                        isOpen={this.state.endPracticeConfirm}
                        header={window.ln.deletePractice + "?"}
                        onDidDismiss={() => { this.setState({ endPracticeConfirm: false }) }}
                        buttons={[
                            {
                                text: window.ln.continueLater,
                                handler: () => { this.endPractice(true) }
                            },
                            {
                                text: window.ln.deletePractice,
                                handler: () => { this.endPractice(false) }
                            }
                        ]}
                    />
                </IonContent>
                <IonFooter>
                    <IonToolbar style={{ '--background': this.state.backgroundColor }}>
                       <IonTitle></IonTitle>
                   </IonToolbar>
               </IonFooter>
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Practice);